import { bestCanonicalBlend, TOP_SCORE_LIMIT, type Attempt } from "../storage";

/// One filled square per stored top-score slot; empty squares for the rest.
const FILLED_GLYPH = "\u{1F7E9}"; // 🟩
const EMPTY_SLOT_GLYPH = "⬜";

/**
 * Renders the day's run as a copy-pasteable summary.
 *
 * Layout (newline-separated, no trailing newline):
 *
 *   CogQuest · YYYY-MM-DD
 *
 *   🟩🟩🟩⬜⬜⬜⬜⬜⬜⬜
 *
 *   best blend: 12345678   (omitted only for zero-attempt states)
 *
 * The grid is always `TOP_SCORE_LIMIT` squares — the number of filled
 * squares is `min(attempts.length, TOP_SCORE_LIMIT)`. Submissions are
 * unbounded; only the top `TOP_SCORE_LIMIT` scores are stored.
 */
export function formatShare(puzzleId: string, attempts: readonly Attempt[]): string {
  const filledCount = Math.min(attempts.length, TOP_SCORE_LIMIT);
  const slots: string[] = [];
  for (let i = 0; i < TOP_SCORE_LIMIT; i++) {
    slots.push(i < filledCount ? FILLED_GLYPH : EMPTY_SLOT_GLYPH);
  }

  const lines = [`CogQuest · ${puzzleId}`, "", slots.join("")];

  const best = bestCanonicalBlend(attempts);
  if (best !== undefined) {
    lines.push("", `best blend: ${best.toString()}`);
  }

  return lines.join("\n");
}
